<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>Trinka Enterprise</h1>
                            <h2>企業・組織の英語発信力をTrinkaでアップ</h2>
                                <p>自動英文校正ツールTrinka（トリンカ）は、組織のワークフローへの統合も簡単。強力な機能のすべてをチームでお使いいただけます。</p>
                                <div class="btn-group">
                                    <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                                    data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                                    <!-- <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">Book a Demo</a> -->
                                </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/enterprise_banner_img.png" alt="Trinka Enterprise - 文法 チェック">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-sm-2">
                    <h2>世界のトップ企業、学術機関もご利用</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="Johnson & Johnson - 英文校正">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" alt="oxford university - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="Harvard Medical School - 英文チ ェッカー">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="merck - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" alt="cambridge university - 英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="Princeton University - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="biogen - 英文 チェック ai">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/UNSW.png" alt="unsw - 英文校正 ai">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="accelera - 英文チ ェッカー">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="pfizer - 文法 チェック">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    
    <div class="cloud_key_features section-pd list-wrapper-style-2 tailoredSolutions">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>組織ごとのニーズに応えるライティングアシスタント</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaのすぐれた辞書機能や汎用性の高さで、機関に所属するメンバーの質の高い英語文書作成をサポートします。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <h3>ライフサイエンス、医療・医薬</h3>
                        <p>Trinkaの強力なAIは、医学・科学分野の文章に求められる精度、専門的な記述の正確さをチェック。分野に応じた文脈に即した修正案を提案します。
                        </p>
                        <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" class="text-link">さらに詳しく
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <h3>言語サービス、出版、メディア</h3>
                        <p>一貫性のある文章の作成、より迅速な出版、そして顧客体験の向上。品質についての妥協をせず、英文ライティングにかかる時間とコストを削減します。</p>
                        <a [routerLink]="['/enterprise/language-services-publishing-and-media']" class="text-link">さらに詳しく
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <h3>学術研究機関</h3>
                        <p>英文を学術的なライティングの規範に沿って磨き上げ、出版に適した文章に仕上げます。</p>
                        <a [routerLink]="['/enterprise/academic-institutions']"  class="text-link">さらに詳しく
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1" style="min-height: 370px;">
                        <h3>教育 & eラーニング</h3>
                        <p>高度なAIを搭載したTrinkaを使っていく中で、英語の学術ライティングの技術が身に付きます。</p>
                        <a [routerLink]="['/enterprise/k12-and-elearning']" class="text-link">さらに詳しく
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1" style="min-height: 370px;">
                        <h3>アプリ・CMS・ソフトウェア</h3>
                        <p>お客様が開発したアプリ・CMS・ソフトウェアへのTrinkaの統合も簡単。アプリケーション上で、リアルタイムのライティングアシスタントが活用できます。</p>
                        <a [routerLink]="['/enterprise/technology-platforms']" class="text-link">さらに詳しく
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="wayToIntegrateTrinka section-pd pt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title mb-50 text-center">
                        <h2>Trinkaを取り入れる3つの方法</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p><span class="OpenSansFonts">Trinka Enterprise</span>で、チームのライティング力をアップ。全ての機能を無制限でご利用いただけ、お客様それぞれのニーズや既存のアプリケーションに合わせた機能の組み込みも可能です。</p>
                    </div>
                </div>
            </div>
            <div class="row divider_line_section">
                <div class="col-lg-5">
                    <div class="integreate_img_section GetTrinkaJs_img">
                        <img class="getTrinkajs_gif_img" src="../../../assets/images/GetTrinkaJs.gif" alt="Trinka JSを追加する - 文法 チェック">
                        <img class="getTrinkaJs_backgrond" src="../../../assets/images/API_backgrond_layer.png" alt="API - 英文校正">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <!-- <b style="padding: 0px 12px 4px 12px;">JS</b> -->
                        <h3>
                            <span>01</span> Trinka JSを追加する</h3>
                        <p>JavaScript(JS)のコードをブラウザなどのアプリケーションに追加することで、チーム全員がTrinkaを利用可能に。複雑なインストール作業なしに、Trinkaのパワフルな機能を手軽にお使いいただけます。</p>
                        <ul>
                            <li>
                                <h4>シンプルなインストール</h4>
                                <p>JavaScriptのコードをアプリケーションに追加するだけでTrinkaを使った質の高いライティングが可能になります。</p>
                            </li>
                            <li>
                                <h4>万全のセキュリティ</h4>
                                <p>データは強固に暗号化されて扱われます。Trinka JSは、リアルタイムに動作しサーバーに情報が保存されることはありません。</p>
                            </li>
                            <li>
                                <h4>高い柔軟性</h4>
                                <p>TrinkaのJavaScriptは、実装が簡単なだけでなく柔軟性も備えています。チームやビジネスの拡張に合わせたスケールアップも可能です。</p>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>

            <div class="row divider_line_section columu_reverse">
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>02</span> TrinkaAPIを活用する</h3>
                        <p>TrinkaのAPIを使えば、自社製品や既存のアプリケーションにTrinkaを簡単に組み込めます。TrinkaのAPIは信頼性や拡張性も抜群です。</p>
                        <ul>
                            <li>
                                <h4>堅牢なAPI</h4>
                                <p>TrinkaではAPIに関する幅広いご要望にお応えし、必要なサポートを随時ご提供しています。</p>
                            </li>
                            <li>
                                <h4>APIのカスタマイズ</h4>
                                <p>アプリケーション特有の要件がある場合もご相談ください。大幅なカスタマイズも可能です。</p>
                            </li>
                            <li>
                                <h4>優れた柔軟性</h4>
                                <p>操作性と柔軟性も抜群。幅広いアプリケーションに組み込めます。</p>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_API">
                        <img class="API_bg_layer" src="../../../assets/images/API_backgrond_layer.png" alt="API - 文法 チェック">
                        <img class="TrinkaAPI_img" src="../../../assets/images/TrinkaAPI_img.png" alt="Trinka API - 英文校正 ai">
                        <div class="API_text_section" data-aos="zoom-in">
                            <span></span>
                            <div class="API_text_overlay"></div>
                            <img src="../../../assets/images/API_text.png" alt="icon - 英文 チェック ai">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_on_premise">
                        <img src="../../../assets/images/GetTrinkaOn_Premise.png" alt="Trinkaオンプレミスを運用する - 文法 チェック">
                        <span class="TrinkaPurpleColor"></span>
                        <span class="TrinkaredColor"></span>
                        <span class="TrinkaYellowColor"></span>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>03</span> Trinkaオンプレミスを運用する</h3>
                        <p>特に機密性の高いデータを取り扱う場合には、Trinkaオンプレミスのシステム内運用が最適。お客様の社内システムの中でご使用いただけます。</p>
                        <ul>
                            <li>
                                <h4>細やかなサポート体制</h4>
                                <p>当社の技術スタッフがお客様の社内ITご担当者様と連携し、導入時にサポートをご提供します。</p>
                            </li>
                            <li>
                                <h4>万全・安心のセキュリティ</h4>
                                <p>Trinka AIは、お客様の社内システム内で安心してご利用いただけます。</p>
                            </li>
                            <li>
                                <h4>高い柔軟性</h4>
                                <p>導入の容易さと細やかなサポート体制で、お客様のチームとビジネスの成長をバックアップいたします。</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-6 col-lg-6">
                    <div class="trinka-title">
                        <h3 class="text-white mb-4">Trinkaのお支払いは、日本円でのお振込みにも対応</h3>
                        <p class="text-white">銀行振り込みでのご利用料金のお支払いをご希望のお客様には請求書をお送りしています。適格請求書がご入用な場合、お気軽にお申し付けください。日本での販売代理店である株式会社クリムゾンインタラクティブ・ジャパンが、日本円建ての適格請求書を発行いたします。</p>
                    </div>
                    <div class="btn-group">
                        <a [routerLink]="['/local-invoice']" class="white-btn">請求書の詳細を見る</a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="text-center mt-sm-30">
                        <img src="../../../assets/images/local-inovice-element.png" alt="現地の請求書 - 英文校正" class="img-fluid" />
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="whiteListing section-pd">
        <div class="trinka_container">
            <div class="row align-items-center" style="margin-bottom: 40px;">
                <div class="col-md-8 col-sm-8">
                    <div class="trinka-title mb-0">
                        <h2>IPホワイトリスト</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>IPホワイトリストとは、機密データやシステムを不正アクセスから保護するためのセキュリティ機能です。リソースの閲覧者を制御することで低コストで効果的にセキュリティ強化を行えるため、機密データを扱う組織で活用されています。ホワイトリストはブラックリストの逆で、信頼できる特定のIPアドレスのみにアクセス権を付与する機能です。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-4">
                    <div class="benefitImage">
                        <img src="../../../assets/images/the-benefit-whitepaper.png" width="200" alt="IPホワイトリスト - 英文チ ェッカー" class="img-fluid" />
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-lg-8 col-sm-12">
                    <div class="trinka-title mb-0">
                        <h3 class="mb-2">メリット</h3>
                        <p>IP ホワイトリストには以下のようなメリットがあります。</p>
                    </div>
                </div>
                
            </div>
            <div class="row match-box">
                <div class="col-sm-6 dflex">
                    <div class="media">
                        <div class="media-body">
                            <h4>セキュリティの強化 <span><img src="../../../assets/images/icons/cyber-security.png" alt="セキュリティの強化 - ai英文校正" /></span></h4>
                            <p>信頼できるIPアドレスからのみTrinkaにアクセスできるため、不正アクセスやサイバー攻撃のリスクを軽減できます。</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="media">
                        <div class="media-body">
                            <h4>管理者によるコントロール <span><img src="../../../assets/images/icons/browser.png" alt=">管理者によるコントロール - 英文 チェック ai" /></span></h4>
                            <p>管理者がIPアドレスの指定および指定解除をすることで、Trinkaにアクセスできるユーザーを制御できます。</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="media">
                        <div class="media-body">
                            <h4>ダウンタイムの削減 <span><img src="../../../assets/images/icons/clock.png" alt="ダウンタイムの削減 - 文法 チェック" /></span></h4>
                            <p>指定IP以外からのアクセスができないため、ユーザーに影響を与える可能性のあるDoS攻撃やアクセス集中のリスクも低減できます。</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="media">
                        <div class="media-body">
                            <h4>コンプライアンスの向上 <span><img src="../../../assets/images/icons/growth.png" alt="コンプライアンスの向上 - 英文校正" /></span></h4>
                            <p>個人情報をはじめ、厳密な管理が組織に求められる情報を保全することができるため、コンプライアンスの向上にもつながります。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-10">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">Trinka Enterpriseで組織のワークフローを強化</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
                        class="white-btn" type="submit">お問い合わせ</button>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>